// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.82.1',
  revision: '098aa873',
  branch: 'master',
  date: 'Thu, 04 Dec 2025 10:32:41 GMT'
};